import Layout from 'utils/layout';
import BundleProduct from './bundle-product';
import BundleSlot from './bundle-slot';

class BundleProducts extends HTMLElement {
  constructor() {
    super();
    this.layout = Layout.getInstance();
    this.handleBpChange = this.handleBpChange.bind(this);
  }

  initSwiper(){
    this.swiper = this.querySelector('swiper-container');

    const prevBtn = this.querySelector('[data-swiper-prev]')
    const nextBtn = this.querySelector('[data-swiper-next]')
    const swiperOptions = {
      shortSwipes: false,
      slidesPerView: 'auto',
      centeredSlides: false,
      spaceBetween: 12,
      slidesOffsetAfter: 90,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      injectStyles: [
        `@media (max-width: 767px) {
         .swiper-wrapper {
           flex-direction: column;
           gap: 10px;
           transform: none !important;
          }
        }
      `,
      ],
    }
    Object.assign(this.swiper, swiperOptions);
    this.swiper.initialize();
    if (!this.layout.isAboveBreakpoint('md')) {
      this.swiper.swiper?.disable();
    }
  }

  handleBpChange() {
    if (this.swiper) {
      if (!this.layout.isAboveBreakpoint('md')) {
        this.swiper.swiper?.disable();
      } else {
        this.swiper.swiper?.enable();
      }
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.initSwiper();
    }, 0);

    window.addEventListener('bpChange', this.handleBpChange);
  }

  disconnectedCallback() {
    window.removeEventListener('bpChange', this.handleBpChange);
  }
}

if (!customElements.get('bundle-products')) {
  customElements.define('bundle-products', BundleProducts);
}

if (!customElements.get('bundle-product')) {
  customElements.define('bundle-product', BundleProduct);
}

if (!customElements.get('bundle-slot')) {
  customElements.define('bundle-slot', BundleSlot);
}